var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrint({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_32681_82236)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.2 5.75H3.8C2.804 5.75 2 6.554 2 7.55V9.95C2 10.61 2.54 11.15 3.2 11.15H4.4V12.35C4.4 13.01 4.94 13.55 5.6 13.55H10.4C11.06 13.55 11.6 13.01 11.6 12.35V11.15H12.8C13.46 11.15 14 10.61 14 9.95V7.55C14 6.554 13.196 5.75 12.2 5.75ZM9.8 12.35H6.2C5.87 12.35 5.6 12.08 5.6 11.75V9.35H10.4V11.75C10.4 12.08 10.13 12.35 9.8 12.35ZM12.2 8.15C11.87 8.15 11.6 7.88 11.6 7.55C11.6 7.22 11.87 6.95 12.2 6.95C12.53 6.95 12.8 7.22 12.8 7.55C12.8 7.88 12.53 8.15 12.2 8.15ZM11 2.75H5C4.67 2.75 4.4 3.02 4.4 3.35V4.55C4.4 4.88 4.67 5.15 5 5.15H11C11.33 5.15 11.6 4.88 11.6 4.55V3.35C11.6 3.02 11.33 2.75 11 2.75Z",
    fill: "#002466"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32681_82236"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.98c85d40629e3c071319352730095321.svg";
export { ForwardRef as ReactComponent };